/**
 * Catalog tool-card kinds whose actionType, entityType, and assistant-ui tool name are identical.
 */
const CATALOG_TOOL_KINDS: ReadonlySet<string> = new Set([
  "sources",
  "assumption_selection",
  "question_answer",
  "hypothesis_selection",
  "experiment_card_selection",
  "assign_experiment",
  "approve_experiment",
  "setup_tracker",
  "lock_tracker",
  "mark_complete",
  "insights_draft",
  "learning_gate",
  "learning_qa",
  "learning_card",
  "connect_source",
]);

/** Retired tool names retained only so persisted holders can hydrate their read-only renderer. */
const HISTORICAL_TOOL_NAMES: ReadonlySet<string> = new Set([
  "workflow_navigation",
]);

/** actionType values whose tool name differs from the actionType itself. */
const ACTION_TYPE_TO_TOOL_NAME: Readonly<Record<string, string>> = {
  plan_confirmation: "experiment_planner",
  asset_help_request: "experiment_planner",
  link_preview: "link_preview",
};

/** entityType values whose tool name differs from the entityType itself. */
const ENTITY_TYPE_TO_TOOL_NAME: Readonly<Record<string, string>> = {
  assumption: "assumption_discovery",
  clarifying_question: "assumption_discovery",
  action_plan: "experiment_planner",
  hypothesis: "experiment_design",
  experiment_card: "experiment_design",
  preview_link: "link_preview",
};

function resolveToolName(key: string, overrides: Readonly<Record<string, string>>): string {
  if (key in overrides) {
    return overrides[key];
  }
  return CATALOG_TOOL_KINDS.has(key) || HISTORICAL_TOOL_NAMES.has(key)
    ? key
    : "unknown_tool";
}

/**
 * Maps actionType (from toolInvoke) to assistant-ui tool names.
 * Use when entity has toolInvoke.actionType; prompts define actionType enums per agent.
 */
export function getToolNameForActionType(actionType: string): string {
  return resolveToolName(actionType, ACTION_TYPE_TO_TOOL_NAME);
}

/**
 * Maps entity types to tool names for the assistant-ui integration.
 * Fallback when actionType is not present (backward compatibility).
 * Works with both old single entity format and new array of entity collections format.
 */
export function getToolNameForEntitiesType(entitiesType: string): string {
  return resolveToolName(entitiesType, ENTITY_TYPE_TO_TOOL_NAME);
}
